













































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IGuest } from "@/@types/admin/guest/user";
import { pensioners } from "@/config/main.config.json";
import { calculateAge as getAge } from "@/services/dateTime/ages";
import { getBirthday } from "@/services/dateTime/getFullDate";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";

import identity_cards from "@/config/identity/identity_cards";
import {
  isValidBirthCertificate,
  isValidPassport,
} from "@/services/user/personal_data";

import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({ components: { BSwitch } })
export default class GuestTableTr extends Vue {
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: Object, default: null }) guest!: IGuest;
  @Prop({ type: Boolean, default: false }) show_comment!: boolean;
  @Prop({ type: Boolean, default: false }) show_gender!: boolean;
  @Prop({ type: Boolean, default: false }) show_email!: boolean;
  @Prop({ type: Boolean, default: false }) show_order_number!: boolean;
  @Prop({ type: Boolean, default: false }) show_ad!: boolean;
  @Prop({ type: Boolean, default: false }) show_room!: boolean;
  @Prop({ type: Boolean, default: false }) show_phone_number!: boolean;
  @Prop({ type: Boolean, default: false }) show_birthday!: boolean;
  @Prop({ type: Boolean, default: false }) show_document!: boolean;
  @Prop({ type: Boolean, default: false }) show_age!: boolean;
  @Prop({ type: Boolean, default: false }) add_some!: boolean;
  @Prop({ type: Boolean, default: false }) show_table!: boolean;
  @Prop({ type: Boolean, default: false }) show_zit!: boolean;
  @Prop({ type: Boolean, default: true }) check!: boolean;
  @Prop({ type: Number, default: 0 }) i!: number;

  get internet_access(): { phone: string; status: string } | null {
    if (!this.guest?.additional_data?.internet_access) return null;
    let internet_access = this.guest.additional_data.internet_access.find(
      (el) => el.status == "access"
    );
    if (internet_access)
      return { phone: internet_access.phone, status: "access" };

    internet_access = this.guest.additional_data.internet_access.find(
      (el) => el.status == "access_by_admin"
    );
    if (internet_access)
      return { phone: internet_access.phone, status: "access_by_admin" };

    internet_access = this.guest.additional_data.internet_access.find(
      (el) => el.status == "access_by_admin"
    );
    if (internet_access)
      return { phone: internet_access.phone, status: "not_verified" };

    internet_access = this.guest.additional_data.internet_access.find(
      (el) => el.status == "activation_failed"
    );
    if (internet_access)
      return { phone: internet_access.phone, status: "activation_failed" };

    return null;
  }

  get isVroom(): boolean {
    for (const vr of this.virtualRooms) {
      if (vr.guests.includes(this.guest._id)) return true;
    }
    return false;
  }

  get birthday(): string {
    if (!this.guest.personal_data?.birthday) return "";
    return getBirthday(this.guest.personal_data.birthday);
  }

  get age(): number {
    if (this.guest.personal_data?.birthday)
      return getAge(this.guest.personal_data.birthday);
    return 0;
  }

  get arrival(): string {
    if (!this.guest.stay_data?.arrival) return "";
    return getBirthday(this.guest.stay_data.arrival);
  }

  get departure(): string {
    if (!this.guest.stay_data?.departure) return "";
    return getBirthday(this.guest.stay_data.departure);
  }

  get guest_bg(): string {
    if (!this.guest?.personal_data?.birthday) return "";
    if (this.age < 18) return "#e3f2fd";
    // // pensioners
    if (!this.guest.personal_data.gender) return "";
    if (this.guest.personal_data.gender == 1 && this.age >= pensioners.men)
      return "#fff8e1";
    if (this.guest.personal_data.gender == 2 && this.age >= pensioners.women)
      return "#fff8e1";
    return "";
  }

  get doc_color(): string {
    if (
      this.guest.personal_data.documents.doctype === null ||
      this.guest.personal_data.documents.doctype === undefined
    )
      return "";
    // Паспорт РФ
    if (this.guest.personal_data.documents.doctype == identity_cards[0]._id) {
      if (!isValidPassport(this.guest.personal_data.documents.number))
        return "text-danger";
    }
    // Свидетельство о рождении
    if (this.guest.personal_data.documents.doctype == identity_cards[4]._id) {
      if (!isValidBirthCertificate(this.guest.personal_data.documents.number))
        return "text-danger";
    }
    return "";
  }

  get doc_number(): string {
    if (
      !this.guest.personal_data?.documents ||
      !this.guest.personal_data.documents.number
    )
      return "";
    if (
      this.guest.personal_data.documents.doctype === null ||
      this.guest.personal_data.documents.doctype === undefined
    )
      return this.guest.personal_data.documents.number;

    // Паспорт РФ
    if (this.guest.personal_data.documents.doctype == identity_cards[0]._id) {
      const length = this.guest.personal_data.documents.number.length;
      if (length > 4)
        return (
          this.guest.personal_data.documents.number.slice(0, 4) +
          " " +
          this.guest.personal_data.documents.number.slice(4, 20)
        );
    }
    // Свидетельство о рождении
    if (this.guest.personal_data.documents.doctype == identity_cards[4]._id) {
      const str = this.guest.personal_data.documents.number;
      const index = str.search(/\d/);
      if (index != -1)
        return (
          this.guest.personal_data.documents.number.slice(0, index) +
          " " +
          this.guest.personal_data.documents.number.slice(index, 20)
        );
    }

    return this.guest.personal_data.documents.number.slice(0, 20);
  }

  onboard(): void {
    const data = this.guest;
    data.onboard = !this.guest.onboard;
    this.$emit("update", data);
  }
}
